
export const isPeriodOverPeriodChart = config => config.periodOverPeriod;
export const POSITIVE_COLOR = 'var(--fc-green-500)';
export const NEGATIVE_COLOR = 'var(--fc-red-500)';
